import type { ComponentProps } from "react"
import Input from "@/v2-ui/input"
import Label from "@/v2-ui/label"

export type UserMfaPhoneFormProps = Omit<ComponentProps<"form">, "onSubmit"> & {
  formId: string
  value: string
  onValueChange(value: string): void
  onSubmit(): void
}

// Presentational phone-number form shared by the add and edit dialogs, so each
// of those owns exactly one mutation and the input markup lives in one place.
function UserMfaPhoneForm(props: UserMfaPhoneFormProps) {
  const { formId, value, onValueChange, onSubmit, ...formProps } = props

  return (
    <form
      id={formId}
      className="space-y-2 py-4"
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
      {...formProps}
    >
      <Label htmlFor={`${formId}-phone`}>Phone number</Label>
      <Input
        id={`${formId}-phone`}
        type="tel"
        required
        autoFocus
        placeholder="+47 412 34 567"
        value={value}
        onChange={(e) => {
          onValueChange(e.target.value)
        }}
      />
      <p className="text-xs text-muted-foreground">
        Use international format, including country code (e.g. +47 412 34 567).
      </p>
    </form>
  )
}

export default UserMfaPhoneForm
